import { getApplicantTypes } from 'services/applicantTypes';
import useFortressQuery from './useFortressQuery';

const useApplicantTypesQuery = (queryOptions = {}) => {
  const queryKey = ['getApplicantTypes'];

  return useFortressQuery({
    queryKey,
    queryFn: ({ signal }) => getApplicantTypes({ signal }),
    ...queryOptions,
  });
};

export default useApplicantTypesQuery;
